import { fetchAirline, fetchPax, fetchPaxsGroup, fetchAirlineShareDetail } from '@/api/common/airline'
import { fetchTitleHeader } from '@/api/common/title'
import { updatePassenger, fetchPaxBoarding, confirmBoarding, fetchPax as refetchPax } from '@/api/passenger'
import { insertInternalComment, fetchOriginCode, callBackCustomer } from '@/api/common'
import { sendEmailConfirm } from '@/api/service'

const sendEmailConfirmReceipt = (context, data) => {
  return sendEmailConfirm(data).then((response) => {
    return response
  })
}

const getAirline = (context) => {
  fetchAirline.then((response) => {
    context.commit('AIRLINE_UPDATED', response)
  })
}

const getAirlineShareDetail = (context) => {
  fetchAirlineShareDetail.then((response) => {
    if (response) {
      context.commit('AIRLINE_UPDATED', response.airline)
      context.commit('PAX_INIT', response.pax_info)
      context.commit('LANG_UPDATED', response.pax_info.lang)
      context.commit('UPDATE_INFO_FLIGHT', true)
    }
  })
}

const getPax = (context) => {
  fetchPax.then((response) => {
    context.commit('PAX_INIT', response)
    context.commit('LANG_UPDATED', response.lang)
  })
}

const reGetPax = (context) => {
  refetchPax().then((response) => {
    context.commit('PAX_INIT', response)
  })
}

const getTitle = (context) => {
  fetchTitleHeader.then((response) => {
    context.commit('GET_TITLE', response)
  })
}

const insertInterCmt = (context, payLoad) => {
  insertInternalComment(payLoad).then((response) => {
    if (response && response.success) {
      context.commit('GET_INTERNAL_CMT_ID', response.internal_comment_id)
    }
  })
}
const getPaxsGroup = (context) => {
  fetchPaxsGroup.then((response) => {
    context.commit('GET_PAXS_GROUP', response)
  })
}

const getOriginCode = (context, shortCode) => {
  return fetchOriginCode(shortCode).then((response) => {
    return response
  })
}

const getCallBackCustomer = (context, passengerId) => {
  return callBackCustomer(passengerId).then((response) => {
    return response
  })
}

const updatePassengerInfo = (context, data) => {
  updatePassenger(data).then((response) => {
    if (response.success === true) {
      context.commit('PAX_UPDATED', response.data)
    }
  })
}

const updatePhoneAndMail = (context, data) => {
  return updatePassenger(data)
    .then((response) => {
      if (response.success) {
        return response
      }
    })
    .catch((e) => {
      console.log(e)
    })
}

const updateReceiveMsg = (context, data) => {
  context.commit('UPDATE_RECEIVE_MESSAGE', data)
}

const getPaxBoarding = () => {
  return fetchPaxBoarding().then((response) => {
    return response
  })
}

const updateStatusBoarding = (context, data) => {
  return confirmBoarding(data).then((response) => {
    return response
  })
}

const updateGoogleApiStatus = (context, status) => {
  context.commit('UPDATE_GOOGLE_API_STATUS', status)
}

export default {
  sendEmailConfirmReceipt,
  getAirline,
  getPax,
  reGetPax,
  getTitle,
  insertInterCmt,
  getPaxsGroup,
  getOriginCode,
  getCallBackCustomer,
  updatePassengerInfo,
  updatePhoneAndMail,
  getAirlineShareDetail,
  updateReceiveMsg,
  getPaxBoarding,
  updateStatusBoarding,
  updateGoogleApiStatus
}
